module.exports = __webpack_public_path__ + "img/PDF.832a91f.svg";